import Pusher from 'pusher-js';
import * as actions from '../actions';
import { storage, retrieveHistory } from '../services/storage';
import { sendMetaData } from '../services/global';
import { api } from '../services/http';
import isInPrivateMode from '../services/private';
import uuid from 'uuid';

let socketOrigin,
	socket;

export function sendMessage(message, store) {
	const messageToSend = {
		body: message.body,
		by: message.by,
		data: message.data,
		type: message.type
	};

	store.dispatch(actions.lastMessageError(false));
	api.post('message/chat/', messageToSend).then(response => {
		if (!store.getState().chatter.get('hasSentFirstMessage')) {
			store.dispatch(actions.setHasSentFirstMessage());
			sendMetaData(store);
		}
	}).catch(error => {
		store.dispatch(actions.lastMessageError(true));
	});
}

// Create  middleware to emit a message when a "ADD_MESSAGE" action is dispatched
export function chatMiddleware(store) {
	return next => action => {
		const result = next(action);
		if (action.type === "ADD_MESSAGE") {
			let messages = store.getState().messages,
			lastMessage = messages.last().toJS();

			lastMessage.by = store.getState().chatter.get("id");

			sendMessage(lastMessage, store);
		}

		return result;
	};
}

export default function (store) {
	socket = new Pusher(process.env.PUSHER_KEY, {
		encrypted: true
	});

	let chatter;

	if (isInPrivateMode()) {
        storage.destroy("history2");
        storage.destroy("history");
        storage.destroy("chatter");
	} else {
		chatter = storage.retrieve("chatter");
	}

	if (chatter === null || chatter === undefined) {
		chatter = uuid.v4();
		store.dispatch(actions.setChatter(chatter));
		if (!isInPrivateMode()) {
			storage.store('chatter', chatter);
		}
	}

	store.dispatch(actions.setChatter(chatter));

	// Wait for 'connected' event to indicate we're connected
	socket.connection.bind('connected', () => {
	  	store.dispatch(actions.setSocketConnected());

	  	let chatHistory = retrieveHistory();
	  	if (!chatHistory || !chatHistory.length) {
	  		store.dispatch(actions.triggerMessageLoader());
	  		sendMessage({
	  			body: "Hello",
	  			by: chatter,
	  			type: "text"
	  		}, store);
	  	}
	});

	// Connect to the channel that delivers control events to the client
	const controlChannel = socket.subscribe('control');
	controlChannel.bind('refresh-requested', event => {
		window.location.reload(true);
	});

	// Connect to the channel that delivers chat messages from the server
	const channel = socket.subscribe(chatter);
	channel.bind('message-sent', response => {
	  	let cumulativeDelay = 300;

	  	response.messages && response.messages.forEach((message, index) => {

	  		cumulativeDelay += (550 + Math.round(Math.random() * 350));

	  		setTimeout(() => {
	  			if (message.type === "link") {
	  				store.dispatch(actions.getLinkResponse(message));
	  			} else {
	  				store.dispatch(actions.addResponse(message, response.source));
	  			}

	  			if (index === (response.messages.length - 1) && response.suggested_responses) {
	  				store.dispatch(actions.addSuggestedResponses(response.suggested_responses));
	  			}
	  		}, cumulativeDelay);
	  	});
	});
}



// WEBPACK FOOTER //
// ./src/services/chat.js